import { AxiosError } from "axios";
import { ClientError } from "graphql-request";
import isNil from "lodash/isNil";
import { GRAPHQL_PATH } from "utils/constants/auth.constants";

export const getRequestUrl = (
  error: AxiosError | Error | ClientError | null,
): string | null | undefined => {
  if (isNil(error)) {
    return null;
  }

  if (error instanceof ClientError) {
    return GRAPHQL_PATH;
  }

  if (error instanceof AxiosError) {
    return error.config?.url;
  }
};
